import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface ICreateMixOrderWidgetProps {
    onClose: () => void;
}

export const CreateMixOrderWidget = ({
    onClose,
}: ICreateMixOrderWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt; <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_create_a_mixed_order"
                        defaultMessage="How do I create a mixed order?"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="help-center-tabs">
                            <ul
                                className="nav nav-pills mb-3"
                                id="pills-tab"
                                role="tablist"
                            >
                                <li className="nav-item active">
                                    <a
                                        className="nav-link show"
                                        id="pills-ric-tab"
                                        data-toggle="pill"
                                        href="#pills-ric"
                                        role="tab"
                                        aria-controls="pills-home"
                                        aria-selected="true"
                                    >
                                        <FormattedMessage
                                            id="RIC_with_Earmold"
                                            defaultMessage="RIC with Earmold"
                                        />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link"
                                        id="pills-ricAbsolutePower-tab"
                                        data-toggle="pill"
                                        href="#pills-ricAbsolutePower"
                                        role="tab"
                                        aria-controls="pills-profile"
                                        aria-selected="false"
                                    >
                                        <FormattedMessage
                                            id="RIC_with_Absolute_Power_Mold"
                                            defaultMessage="RIC with Absolute Power Mold"
                                        />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link"
                                        id="pills-bteEarmold-tab"
                                        data-toggle="pill"
                                        href="#pills-bteEarmold"
                                        role="tab"
                                        aria-controls="pills-contact"
                                        aria-selected="false"
                                    >
                                        <FormattedMessage
                                            id="BTE_with_Earmold"
                                            defaultMessage="BTE with Earmold"
                                        />
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <h3>
                                    <FormattedMessage
                                        id="Step_by_step_guide"
                                        defaultMessage="Step by Step Guide"
                                    />
                                </h3>
                                <div
                                    className="tab-pane fade active in"
                                    id="pills-ric"
                                    role="tabpanel"
                                    aria-labelledby="pills-ric -tab"
                                >
                                    <ol className="ordered-list">
                                        <li>
                                            <FormattedMessage
                                                id="Click_on_Shop_Hearing_Aids_under_Quick_Links"
                                                defaultMessage="Step 1. Click on 'Shop Hearing Aids' under 'Quick Links' and filter out which product you would like to order"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="On_the_order_form_page_select"
                                                defaultMessage="Step 2. On the order form page, select 'yes' under 'Is this for a patient?'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Choose_Fit_Options_select_Earmold"
                                                defaultMessage="Step 3. Under 'Choose Fit Options' select 'Earmold'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="After_selecting_the_Earmold_option"
                                                defaultMessage="Step 4. After selecting the 'Earmold' option you will have to fill out the 'send impressions' section"
                                            />
                                            <ul className="ordered-list-sec">
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_Send_physical_impressions"
                                                        defaultMessage="If you select 'Send physical impressions' the order will not be started until we receive the physical impressions"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_a_digital_impression_option"
                                                        defaultMessage="If you select a digital impression option, the order will be submitted to us once it is complete. You should receive a green check mark with patient name if we have a digital impression on file"
                                                    />
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Fill_out_the_Audiogram_for_the_patient"
                                                defaultMessage="Step 5. Fill out the 'Audiogram' for the patient (Thresholds needed for 500, 1k, 2k and 4k)"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Product_Options_you_will_need"
                                                defaultMessage="Step 6. Under 'Product Options' you will need to select receiver cable length"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_a_drop_down"
                                                defaultMessage="Step 7. There will be a drop down under 'SELECT EARMOLD TYPE' where you will select the style of earmold"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_choose_Material_Receiver_Gain_Earmold"
                                                defaultMessage="Step 8. Next choose Material, Receiver Gain, Earmold Color, Venting Options and General additions to complete the order form"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_you_can_add_accessories_or_common_RIC_earmold"
                                                defaultMessage="Step 9. Next you can add accessories or common supplies to the order if needed"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_an_option_to_add_special"
                                                defaultMessage="Step 10. There will be an option to add special instructions if needed before clicking on 'ADD TO CART'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="A_pop_up_will_appear_prompting_you_RIC_earmold"
                                                defaultMessage="Step 11. A pop-up will appear, prompting you to click on 'PROCEED TO CHECKOUT'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_step_will_be_to_Review_Order_RIC_earmold"
                                                defaultMessage="Step 12. Next step will be to 'Review Order' and 'Place Order'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_clear_instructions"
                                                defaultMessage="Step 13. There will be clear instructions to send in paperwork with impressions if needed or that the order was submitted and no further action required."
                                            />
                                        </li>
                                    </ol>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="pills-ricAbsolutePower"
                                    role="tabpanel"
                                    aria-labelledby="pills-ricAbsolutePower-tab"
                                >
                                    <ol className="ordered-list">
                                        <li>
                                            <FormattedMessage
                                                id="Click_on_Shop_Hearing_Aids_under"
                                                defaultMessage="Step 1. Click on 'Shop Hearing Aids' under 'Quick Links' and filter out which product you would like to order"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="On_the_order_form_page"
                                                defaultMessage="Step 2. On the order form page, select 'yes' under 'Is this for a patient?'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Choose_Fit_Options"
                                                defaultMessage="Step 3. Under 'Choose Fit Options' select 'Earmold'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="After_selecting_the_Earmold_option"
                                                defaultMessage="Step 4. After selecting the 'Earmold' option you will have to fill out the 'send impressions' section"
                                            />
                                            <ul className="ordered-list-sec">
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_Send_physical_impressions"
                                                        defaultMessage="If you select 'Send physical impressions' the order will not be started until we receive the physical impressions"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_a_digital_impression_option"
                                                        defaultMessage="If you select a digital impression option, the order will be submitted to us once it is complete. You should receive a green check mark with patient name if we have a digital impression on file"
                                                    />
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Fill_out_the_Audiogram_for_the_patient"
                                                defaultMessage="Step 5. Fill out the 'Audiogram' for the patient (Thresholds needed for 500, 1k, 2k and 4k)"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Custom_options_you_will_be_asked"
                                                defaultMessage="Step 6. Under Custom options you will be asked if you want us to choose the best options for you or not. If you select 'yes' we will choose the best gain and venting options based off of the audiogram provided. If you select 'no' you can choose your own gain and venting options."
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_for_Product_Options_you_can"
                                                defaultMessage="Stetp 7. Next for Product Options, you can select a canal lock if needed and select receiver cable length"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_you_can_add_accessories_or_common_RIC_absolute"
                                                defaultMessage="Step 8. Next you can add accessories or common supplies to the order if needed"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_an_option_to_add"
                                                defaultMessage="Step 9. There will be an option to add special instructions if needed before clicking on 'ADD TO CART'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="A_pop_up_will_appear_prompting_you_RIC_absolute"
                                                defaultMessage="Step 10. A pop-up will appear, prompting you to click on 'PROCEED TO CHECKOUT'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_step_will_be_to_Review_Order_RIC_absolute"
                                                defaultMessage="Step 11. Next step will be to 'Review Order' and 'Place Order'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_clear_instructions_RIC_absolute"
                                                defaultMessage="Step 12. There will be clear instructions to send in paperwork with impressions if needed or that the order was submitted and no further action required."
                                            />
                                        </li>
                                    </ol>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="pills-bteEarmold"
                                    role="tabpanel"
                                    aria-labelledby="pills-bteEarmold-tab"
                                >
                                    <ol className="ordered-list">
                                        <li>
                                            <FormattedMessage
                                                id="Click_on_Shop_Hearing_Aids_under"
                                                defaultMessage="Step 1. Click on 'Shop Hearing Aids' under 'Quick Links' and filter out which product you would like to order"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="On_the_order_form_page"
                                                defaultMessage="Step 2. On the order form page, select 'yes' under 'Is this for a patient?'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Choose_Fit_Options"
                                                defaultMessage="Step 3. Under 'Choose Fit Options' select 'Earmold'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="After_selecting_the_Earmold_option"
                                                defaultMessage="Step 4. After selecting the 'Earmold' option you will have to fill out the 'send impressions' section"
                                            />
                                            <ul className="ordered-list-sec">
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_Send_physical_impressions"
                                                        defaultMessage="If you select 'Send physical impressions' the order will not be started until we receive the physical impressions"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="If_you_select_a_digital_impression_option"
                                                        defaultMessage="If you select a digital impression option, the order will be submitted to us once it is complete. You should receive a green check mark with patient name if we have a digital impression on file"
                                                    />
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Fill_out_the_Audiogram_for_the_patient"
                                                defaultMessage="Step 5. Fill out the 'Audiogram' for the patient (Thresholds needed for 500, 1k, 2k and 4k)"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Under_Earmold_Options_you_will_select"
                                                defaultMessage="Step 6. Under Earmold Options you will select 'style' and 'sub style'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="After_selecting_earmold_type_you_will"
                                                defaultMessage="Step 7. After selecting earmold type, you will need to fill out Material, Mold Color, Venting, Tubing and Canal Length options"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_you_can_add_accessories_or_common_RIC_absolute"
                                                defaultMessage="Step 8. Next you can add accessories or common supplies to the order if needed"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_an_option_to_add"
                                                defaultMessage="Step 9. There will be an option to add special instructions if needed before clicking on 'ADD TO CART'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="A_pop_up_will_appear_prompting_you_RIC_absolute"
                                                defaultMessage="Step 10. A pop-up will appear, prompting you to click on 'PROCEED TO CHECKOUT'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="Next_step_will_be_to_Review_Order_RIC_absolute"
                                                defaultMessage="Step 11. Next step will be to 'Review Order' and 'Place Order'"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="There_will_be_clear_instructions_RIC_absolute"
                                                defaultMessage="Step 12. There will be clear instructions to send in paperwork with impressions if needed or that the order was submitted and no further action required."
                                            />
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const createMixOrderWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateMixOrderWidget);

export default createMixOrderWidgetContainer;
